'use client';

import {IMGPW} from '@/config';
import {useTranslations} from 'next-intl';
import { FC, useState } from 'react';
import BusinessForm from '../../../../../components/google-forms/BusinessForm';
import BusinessHeader from '../../components/BusinessHeader';
import {SuccessModal} from '../../components/SuccessModal';
import Image from 'next/image';

interface Props {}

const VirtualEvent: FC<Props> = () => {
  const t = useTranslations('business');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const onFormSent = () => {
    setIsModalOpen(true);
  };

  return (
    <div>
      <div className="section-container mt-4">
        <Image
          height={100}
          width={178}
          src={IMGPW + '/WL_for_business.png'}
          alt="Winelivery For Business" />
      </div>
      <BusinessHeader
        title={t('VirtualEvents.Header.Title')}
        subtitle={t('VirtualEvents.Header.Subtitle')}
        paragraph={t('VirtualEvents.Header.Paragraph')}
        imgSrc={IMGPW + '/business/evento-virtuale.jpg'}
        maxHeight={400}
      />
      <div className="section-container mb-12" id="form">
        <BusinessForm
          formType={'team-building-virtuale'}
          section="virtual"
          onSent={onFormSent}
        />
      </div>
      <SuccessModal isOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </div>
  );
};

export default VirtualEvent;
